export function toEmbedUrl(url) {
  if (!url) {
    return null;
  }

  const match = String(url).match(/instagram\.com\/(reel|p|tv)\/([A-Za-z0-9_-]+)/);

  if (!match) {
    return null;
  }

  return `https://www.instagram.com/${match[1]}/${match[2]}/embed`;
}

export default function InstagramEmbed({ url, className = "" }) {
  const embedUrl = toEmbedUrl(url);

  if (!embedUrl) {
    return null;
  }

  return (
    <div
      className={className}
      data-testid="instagram-embed"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <iframe
        src={embedUrl}
        title="Instagram відео"
        loading="lazy"
        allowFullScreen
        scrolling="no"
        data-testid="instagram-embed-frame"
        style={{
          width: "100%",
          maxWidth: 400,
          height: 700,
          border: "none",
          borderRadius: 12,
          background: "#000"
        }}
      />
    </div>
  );
}